module.exports = __webpack_public_path__ + "media/images/ecute/ecuteueno_en-42447c4ed7364746bceb9353d85ba8aa.jpg";